import React, { createContext, useContext, useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

export const TabsPortalContext = createContext()

const TabsPortalProvider = ({ location, children }) => {
  const [tabsPortalRef] = useState(location)

  return <TabsPortalContext.Provider value={tabsPortalRef}>{children}</TabsPortalContext.Provider>
}

export const TabsListPortal = ({ children }) => {
  const tabsPortalRef = useContext(TabsPortalContext)
  const [portalReady, setPortalReady] = useState(false)

  useEffect(() => {
    setPortalReady(true)
  }, [tabsPortalRef])

  return portalReady && tabsPortalRef?.current ? createPortal(children, tabsPortalRef.current) : children
}

export default TabsPortalProvider
